@use "../../../common/scss/colors";
@use "../../../common/scss/font";
@use "../../../common/scss/mixins";

.lpb_container {
  margin: 0 1rem;
  width: 93%;
  padding: 1rem;
}

.LeafPerfBonusScale {
  display: flex;

  &__container {
    padding-top: 2rem;
    padding-bottom: 2rem;
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__progress-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 0.5rem;
    background-color: colors.$light_gray;
    border-radius: 0.25rem 0 0 0.25rem;
    position: relative;
  }

  &__edge {
    height: 0.5rem;
    width: 0.375rem;
    background-color: colors.$light_gray;
    border-radius: 0 0.25rem 0.25rem 0;
  }

  &__forward {
    display: block;
    width: 1.6rem;
    text-align: right;
    padding: 1.8rem 0;
    cursor: pointer;

    svg {
      cursor: pointer;
    }
  }

  &__back {
    display: flex;
    width: 1.4rem;
    justify-content: flex-end;
    padding: 1.8rem 0;
    cursor: pointer;

    span {
      width: 0.625rem;
      padding-top: 2px;
    }

    svg {
      cursor: pointer;
    }
  }

  &__progress-filled {
    height: 100%;
    border-radius: 0.312rem;
    background-color: colors.$blue;
  }

  &__progress-mark {
    position: absolute;
    margin-top: 3px;
    transform: translateX(-50%);
  }

  &__tick {
    position: absolute;
    top: 0;
    height: 100%;
    width: 1px;
    background-color: colors.$white;
  }

  &__tick-number {
    position: absolute;
    top: 0.625rem;
    color: colors.$dark_grey_on_white;
    font-size: font.$size--standard;
    white-space: nowrap;

    &--first {
      transform: translateX(0);
      text-align: left;
    }

    &--middle {
      transform: translateX(-50%);
      text-align: center;
    }

    &--last {
      transform: translateX(-100%);
      text-align: right;
    }

    &--single {
      transform: translateX(-100%) !important;
      text-align: right !important;
    }
  }

  &__tick-percent {
    position: absolute;
    font-size: 0.66rem;
    top: 1px;
  }

  &__milestone {
    position: absolute;
    bottom: 1.35rem;
    height: 100%;
    transform: translateX(-50%);
  }

  &__legend {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    gap: 2rem;
    place-items: center flex-start;
    padding: 0 1.5rem;

    @include mixins.md_s {
      gap: 1rem;
    }

    @include mixins.md {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }
  }

  &__legend-item {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    gap: 0.3rem;
    font-size: font.$size--standard;

    @include mixins.md {
      font-size: font.$size--medium;
    }
  }
}

.LeafPerfBonusScale__part {
  .LeafPerfBonusScale__edge {
    width: 0.25rem;
    border-radius: 0;
  }
}
